import { render, staticRenderFns } from "./Storages.vue?vue&type=template&id=8aa3efee"
import script from "./Storages.vue?vue&type=script&lang=ts"
export * from "./Storages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports